import { render, staticRenderFns } from "./Page006.vue?vue&type=template&id=4391a9f5&scoped=true&"
import script from "./Page006.vue?vue&type=script&lang=js&"
export * from "./Page006.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4391a9f5",
  null
  
)

export default component.exports